import cx from "classnames";
import { Icon } from "common/Icon";
import { accountLevels, useFormatMessage } from "lib/localization";
import React from "react";
import { defineMessages } from "react-intl";
import styles from "./AccountTypeBadge.scss";

const accountMessages = defineMessages({
  subscriber: {
    id: "accountMessages.subscriber",
    defaultMessage: "{level} Subscriber",
  },
});

export const AccountTypeBadge = ({ accountLevel, className, ...props }) => {
  const fm = useFormatMessage();
  if (accountLevel === 1) {
    return (
      <Icon
        i="icon-basic"
        data-tip
        title={fm(accountMessages.subscriber, {
          level: fm(accountLevels.basic),
        })}
        className={cx(styles.basic, className)}
        {...props}
      />
    );
  } else if (accountLevel >= 2) {
    return (
      <Icon
        i="icon-premium"
        data-tip
        title={fm(accountMessages.subscriber, {
          level: fm(accountLevels.premium),
        })}
        className={cx(styles.premium, className)}
        {...props}
      />
    );
  } else {
    return null;
  }
};
